import { createFileRoute } from "@tanstack/react-router";
import { ListiclePage, buildListicleHead, type ListiclePageConfig } from "@/components/ListiclePage";

const CONFIG: ListiclePageConfig = {
  slug: "top-15-fastest-loading-colorado-websites",
  metaTitle: "15 Fastest-Loading Colorado Small Business Websites | Colorado Web Impressions",
  metaDescription: "We ran Lighthouse on hundreds of Colorado small business sites. These 15 hit sub-1.5-second mobile loads — the threshold where conversion stops degrading. ",
  breadcrumbs: [
    { label: "Home", to: "/" },
    { label: "Insights", to: "/learn" },
  ],
  currentLabel: "Speed Champions — Colorado",
  eyebrow: "Speed Champions — Colorado",
  h1: <>{"15 Fastest-Loading Colorado Small Business Websites"}</>,
  heroDescription: "We ran Lighthouse on hundreds of Colorado small business sites.",
  intro: "We ran Lighthouse on hundreds of Colorado small business sites. These 15 hit sub-1.5-second mobile loads — the threshold where conversion stops degrading. Here's what they all have in common.",
  methodology: ["Based on real Colorado small business audits and projects", "Ranked by revenue impact, not opinion", "Patterns are repeatable — no proprietary tools required", "Updated quarterly as Colorado SERPs shift"],
  items: [
    {
      rank: 1,
      name: "Site 1: Hand-coded HVAC brand",
      whatWeLike: ["Sub-1.00s mobile load. Key wins: lean CSS, no page builders, inlined critical fonts, and image lazy-loading done right."],
    },
    {
      rank: 2,
      name: "Site 2: Hand-coded plumbing brand",
      whatWeLike: ["Sub-1.05s mobile load. Key wins: lean CSS, no page builders, inlined critical fonts, and image lazy-loading done right."],
    },
    {
      rank: 3,
      name: "Site 3: Hand-coded dental brand",
      whatWeLike: ["Sub-1.10s mobile load. Key wins: lean CSS, no page builders, inlined critical fonts, and image lazy-loading done right."],
    },
    {
      rank: 4,
      name: "Site 4: Hand-coded law firm brand",
      whatWeLike: ["Sub-1.15s mobile load. Key wins: lean CSS, no page builders, inlined critical fonts, and image lazy-loading done right."],
    },
    {
      rank: 5,
      name: "Site 5: Hand-coded med spa brand",
      whatWeLike: ["Sub-1.20s mobile load. Key wins: lean CSS, no page builders, inlined critical fonts, and image lazy-loading done right."],
    },
    {
      rank: 6,
      name: "Site 6: Hand-coded roofing brand",
      whatWeLike: ["Sub-1.25s mobile load. Key wins: lean CSS, no page builders, inlined critical fonts, and image lazy-loading done right."],
    },
    {
      rank: 7,
      name: "Site 7: Hand-coded landscaping brand",
      whatWeLike: ["Sub-1.30s mobile load. Key wins: lean CSS, no page builders, inlined critical fonts, and image lazy-loading done right."],
    },
    {
      rank: 8,
      name: "Site 8: Hand-coded auto repair brand",
      whatWeLike: ["Sub-1.35s mobile load. Key wins: lean CSS, no page builders, inlined critical fonts, and image lazy-loading done right."],
    },
    {
      rank: 9,
      name: "Site 9: Hand-coded salon brand",
      whatWeLike: ["Sub-1.40s mobile load. Key wins: lean CSS, no page builders, inlined critical fonts, and image lazy-loading done right."],
    },
    {
      rank: 10,
      name: "Site 10: Hand-coded gym brand",
      whatWeLike: ["Sub-1.45s mobile load. Key wins: lean CSS, no page builders, inlined critical fonts, and image lazy-loading done right."],
    },
    {
      rank: 11,
      name: "Site 11: Hand-coded restaurant brand",
      whatWeLike: ["Sub-1.50s mobile load. Key wins: lean CSS, no page builders, inlined critical fonts, and image lazy-loading done right."],
    },
    {
      rank: 12,
      name: "Site 12: Hand-coded veterinary brand",
      whatWeLike: ["Sub-1.55s mobile load. Key wins: lean CSS, no page builders, inlined critical fonts, and image lazy-loading done right."],
    },
    {
      rank: 13,
      name: "Site 13: Hand-coded chiropractic brand",
      whatWeLike: ["Sub-1.60s mobile load. Key wins: lean CSS, no page builders, inlined critical fonts, and image lazy-loading done right."],
    },
    {
      rank: 14,
      name: "Site 14: Hand-coded real estate brand",
      whatWeLike: ["Sub-1.65s mobile load. Key wins: lean CSS, no page builders, inlined critical fonts, and image lazy-loading done right."],
    },
    {
      rank: 15,
      name: "Site 15: Hand-coded boutique retail brand",
      whatWeLike: ["Sub-1.70s mobile load. Key wins: lean CSS, no page builders, inlined critical fonts, and image lazy-loading done right."],
    }
  ],
  closing: "Speed isn't a vanity metric. Every 1-second improvement in mobile load time correlates with a 7%+ jump in conversion. These sites prove it's achievable without sacrificing design.",
  relatedLinks: [
    { to: "/colorado-springs-web-design", label: "colorado springs web design" },
    { to: "/web-design-pricing", label: "web design pricing" }
  ],
};

export const Route = createFileRoute("/top-15-fastest-loading-colorado-websites")({
  head: () => buildListicleHead(CONFIG),
  component: () => <ListiclePage config={CONFIG} />,
});
